/**
 * Defines a supported chain
 *
 * @typedef Chain
 * @type {object}
 * @property {string} chainId - The chainId for the chain.
 * @property {RpcEndpoint[]} rpcEndpoints - One or more rpcEndpoints associated with that chainId.
 */

/**
 * Defines an RpcEndpoint
 *
 * @typedef RpcEndpoint
 * @type {object}
 * @property {string} protocol
 * @property {string} host
 * @property {number} port
 * @property {string} path
 */